import ItemImage from './ItemImage'

export default ItemImage
